import React from "react";
import Header from "../header";
import Footer from "../footer/Footer";
import ChatBot from "../chatbot/Chatbot";
import WhatsAppChat from "../whatsAppChat/WhatsApp";
import { ToastContainer } from "react-toastify";
// import HeaderT from "../header/headerT";

function Layout({ children }) {
  return (
    <div>
      <div className="fixed w-full bg-white z-50">
      <Header />

      </div>
      {/* <HeaderT /> */}
      <div className="pt-12 lg:pt-28">
      {children}

      </div>
      <WhatsAppChat />

      <ChatBot />
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default Layout;
